import { Component, OnInit } from '@angular/core';
import { HrService } from 'src/app/_services/hr-management/hr.service';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-tax-regim-report',
  templateUrl: './tax-regim-report.component.html',
  styleUrls: ['./tax-regim-report.component.scss']
})
export class TaxRegimReportComponent implements OnInit {
  currentUserId: any;
  currentUser: any;
  tenantId: any;
  userDropdownList = [];
  getUserName: any;
  taxregimForm: any;
  financialYear: any;
  year: any;
  id: any;
  deductions: any;
  payables: any;
  totalPayable: any;
  totalDeduction: any;
  totalTax: any;
  netPayable: any;
  other: any;
  deductions1: any;
  payables1: any;
  totalPayable1: any;
  totalDeduction1: any;
  totalTax1: any;
  netPayable1: any;
  other1: any;
  sharedDeduction: any;
  professionalTax: any;
  hra: any;
  section80TTA: any;
  section80E: any;
  section80DMediclaim: any;
  section80C: any;
  gratuityPayment: any;
  sharedDeduction1: any;
  professionalTax1: any;
  hra1: any;
  section80TTA1: any;
  section80E1: any;
  section80DMediclaim1: any;
  section80C1: any;
  gratuityPayment1: any;
  incomeFromHousePropertySection3: any;
  incomeFromHousePropertySection31: any;
  grossSalaryOutput: any;
  exemptionUS10Output: any;
  incomeChargableUnderHeadSalariesOutput: any;
  exemptionAfterOtherIncomeOutput: any;
  netTaxableIncomeOutput: any;
  grossSalaryOutput1: any;
  exemptionUS10Output1: any;
  incomeChargableUnderHeadSalariesOutput1: any;
  exemptionAfterOtherIncomeOutput1: any;
  netTaxableIncomeOutput1: any;
  section80CCD1: any;
  section80CCD: any;
  section80CCD2: any;
  section80CCD21: any;
  section80DD: any;
  section80DD1: any;
  section80DDB: any;
  section80DDB1: any;
  section80EEA: any;
  section80EEA1: any;
  section80EEB: any;
  section80EEB1: any;
  section80GGGAGGC: any;
  section80GGGAGGC1: any;
  section80GG: any;
  section80GG1: any;
  section80U: any;
  section80U1: any;
  healthAndEducationCess: any;
  healthAndEducationCess1: any;
  totalTaxDue: any;
  totalTaxDue1: any;
  incomeLossOnHouseProperty: any;
  incomeLossOnHouseProperty1: any;

  constructor(
    private HrService: HrService,
    private storageService: LocalStorageService,
    private allocationService: AllocationService,
  ) { 
    this.taxregimForm = new FormGroup({
      financialYear: new FormControl(''),
      year: new FormControl(''),
      userId: new FormControl(''),
    })
  }

  ngOnInit(): void {
    this.currentUserId = JSON.parse(this.storageService.get('currentUser'));
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.tenantId = this.storageService.get('tenantId');
    this.getUserList();
  }


  getUserList() {
    this.userDropdownList = [];
    this.allocationService.getUserDetails().subscribe((response) => {
      this.getUserName = response;
      for (let item of response) {
        this.userDropdownList.push(
          `${item.id} . ${item.firstName} ${item.lastName}`
        );
      }
    });
  }

  getTaxRegim() {
    this.financialYear = this.taxregimForm.get('financialYear').value;
    this.year = this.taxregimForm.get('year').value;
    let userId = this.taxregimForm.get('userId').value.split(' . ')[0];

    if(userId){
      this.id = userId;
    }else{
      this.id = this.currentUserId.id;
    }

    this.HrService.getOldTaxRegim(this.id,this.year,this.financialYear).subscribe(
      (response) => {
        console.log("response",response);
        if (response){
          this.deductions= response.deductions;
          this.payables= response.payables;
          this.totalPayable= response.totalPayable;
          this.totalDeduction= response.totalDeduction;
          this.totalTax= response.totalTax;
          this.netPayable= response.netPayable;
          this.other= response.other;
          this.healthAndEducationCess= response.healthAndEducationCess;
          this.totalTaxDue= response.totalTaxDue;
          
          ;
          console.log("payables", this.payables);
          console.log("deductions", this.deductions);
        }
      },
      (error) => {
        console.log('ERROR: cannot get project by id: ' + error);
      }
    );

    this.HrService.getNewTaxRegim(this.id,this.year,this.financialYear).subscribe(
      (response) => {
        console.log("response",response);
        if (response){
          this.deductions1= response.deductions;
          this.payables1= response.payables;
          this.totalPayable1= response.totalPayable;
          this.totalDeduction1= response.totalDeduction;
          this.totalTax1= response.totalTax;
          this.netPayable1= response.netPayable;
          this.other1= response.other;
          this.healthAndEducationCess1= response.healthAndEducationCess;
          this.totalTaxDue1= response.totalTaxDue;
          
          
          console.log("payables1", this.payables1);
          console.log("deductions1", this.deductions1);
        }
      },
      (error) => {
        console.log('ERROR: cannot get project by id: ' + error);
      }
    );
    
  
      this.HrService.getTaxDeductionOld(this.id,this.financialYear).subscribe(
        (response:any) =>{
        console.log("response",response);
        if (response){
          this.sharedDeduction=  response.result[0].sharedDeduction;
          this.professionalTax= response.result[0].professionalTax;
          this.hra = response.result[0].hra;
          this.section80TTA = response.result[0].section80TTA;
          this.section80E = response.result[0].section80E;
          this.section80DMediclaim = response.result[0].section80DMediclaim;
          this.section80C = response.result[0].section80C;
          this.gratuityPayment = response.result[0].gratuityPayment;
          this.incomeFromHousePropertySection3 = response.result[0].incomeFromHousePropertySection3;
          this.grossSalaryOutput = response.result[0].grossSalaryOutput;
          this.exemptionUS10Output = response.result[0].exemptionUS10Output;
          this.incomeChargableUnderHeadSalariesOutput = response.result[0].incomeChargableUnderHeadSalariesOutput;
          this.exemptionAfterOtherIncomeOutput = response.result[0].exemptionAfterOtherIncomeOutput;
          this.netTaxableIncomeOutput = response.result[0].netTaxableIncomeOutput;
          this.section80CCD = response.result[0].section80CCD;
          this.section80CCD2 = response.result[0].section80CCD2;
          this.section80DD = response.result[0].section80DD;
          this.section80DDB = response.result[0].section80DDB;
          this.section80EEA = response.result[0].section80EEA;
          this.section80EEB = response.result[0].section80EEB;
          this.section80GGGAGGC = response.result[0].section80GGGAGGC;
          this.section80GG = response.result[0].section80GG;
          this.section80U = response.result[0].section80U;
          this.incomeLossOnHouseProperty = response.result[0].incomeLossOnHouseProperty;
          
          console.log("professionalTax", this.professionalTax);
        }
      },
      (error) => {
        console.log('ERROR: cannot get project by id: ' + error);
      }
      );


      this.HrService.getTaxDeductionNew(this.id,this.financialYear).subscribe(
        (response:any) =>{
        console.log("response",response);
        if (response){
          this.sharedDeduction1=  response.result[0].sharedDeduction;
          this.professionalTax1= response.result[0].professionalTax;
          this.hra1 = response.result[0].hra;
          this.section80TTA1 = response.result[0].section80TTA;
          this.section80E1 = response.result[0].section80E;
          this.section80DMediclaim1 = response.result[0].section80DMediclaim;
          this.section80C1 = response.result[0].section80C;
          this.gratuityPayment1 = response.result[0].gratuityPayment;
          this.incomeFromHousePropertySection31 = response.result[0].incomeFromHousePropertySection3;
          this.grossSalaryOutput1 = response.result[0].grossSalaryOutput;
          this.exemptionUS10Output1 = response.result[0].exemptionUS10Output;
          this.incomeChargableUnderHeadSalariesOutput1 = response.result[0].incomeChargableUnderHeadSalariesOutput;
          this.exemptionAfterOtherIncomeOutput1 = response.result[0].exemptionAfterOtherIncomeOutput;
          this.netTaxableIncomeOutput1 = response.result[0].netTaxableIncomeOutput;
          this.section80CCD1 = response.result[0].section80CCD;
          this.section80CCD21 = response.result[0].section80CCD2;
          this.section80DD1 = response.result[0].section80DD;
          this.section80DDB1 = response.result[0].section80DDB;
          this.section80EEA1 = response.result[0].section80EEA;
          this.section80EEB1 = response.result[0].section80EEB;
          this.section80GGGAGGC1 = response.result[0].section80GGGAGGC;
          this.section80GG1 = response.result[0].section80GG;
          this.section80U1 = response.result[0].section80U;
          this.incomeLossOnHouseProperty1 = response.result[0].incomeLossOnHouseProperty;
          console.log("professionalTax", this.professionalTax);
        }
      },
      (error) => {
        console.log('ERROR: cannot get project by id: ' + error);
      }
      );

    }
  


}
